import { useEffect, useState } from "react";
import { apiClient } from "@/services/base.service";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import dayjs from "dayjs";

export const ActiveVisitorsByTime = () => {
  const [chartData, setChartData] = useState<any[]>([]);

  useEffect(() => {
    async function getVisitors() {
      const res = await apiClient.get(
        `${process.env.REACT_APP_SERVER_URL}/visitor/active`
      );

      if (res && res.status === 200) {
        const mapped = res.data.map((v: any) => ({
          time: dayjs(v.lastSeen).format("YYYY-MM-DD HH:mm:ss"),
          ip: v.ip,
          endpoint: v.endpoint,
          agent: v.agent,
          value: 1, // grafik için sabit değer
        }));
        setChartData(mapped);
      }
    }

    getVisitors();
  }, []);

  // Özel tooltip bileşeni
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      const v = payload[0].payload;
      return (
        <div
          style={{
            background: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
            maxWidth: 300,
          }}
        >
          <p>
            <strong>Zaman:</strong> {label}
          </p>
          <p>
            <strong>IP:</strong> {v.ip}
          </p>
          <p>
            <strong>Sayfa:</strong> {v.endpoint}
          </p>
          <p>
            <strong>Tarayıcı:</strong> {v.agent}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ width: "100%", height: 400 }}>
      <h2>Ziyaretçi Detay Zaman Grafiği</h2>
      <ResponsiveContainer>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" />
          <YAxis allowDecimals={false} domain={[0, 1]} />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="value"
            name="Ziyaretçi"
            stroke="#8884d8"
            dot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ActiveVisitorsByTime;
